import React, { useEffect, useState } from "react";
import Api from "../../services/api";

export default function Comments({
  question_id,
  fiscal_year_id,
  posted,
  ocmcm_id,
}) {
  console.log("ocmcm_id,", ocmcm_id, fiscal_year_id);

  const [data, setData] = useState([]);
  console.log("data", data);
  const [loading, setLoading] = useState([]);
  const getData = async () => {
    setLoading(true);
    // let gnid = window.location.search.substring(6);
    let response;
    if (ocmcm_id) {
      response = await Api.getProvincialComments(
        fiscal_year_id,
        question_id,
        sessionStorage.getItem("province_id")
      );
    } else {
      response = await Api.getComments(
        fiscal_year_id,
        question_id,
        sessionStorage.getItem("m_id")
      );
    }

    if (response.code === 200) {
      setData(response.response);
      setLoading(false);
    }
  };
  useEffect(() => {
    getData();
  }, [posted]);
  return loading ? (
    <p>Loading...</p>
  ) : (
    <div>
      {data && data.comments && data.comments.map((item) => (
        <div className="comment-list">
          <legend>{item.created_by}</legend>
          <p>{item.message}</p>
          <legend>{item.created_at.substring(0, 10)}</legend>
        </div>
      ))}
    </div>
  );
}
